<div class="pull-right">
    {{ 'LAYOUT.FOOTER.VERSION' | translate }} <strong>{{ settings.app.version }}</strong>
</div>
<div>
    <strong>{{ settings.app.name }}</strong> &copy; {{ settings.app.year }}
</div>